module.exports = __webpack_public_path__ + "media/application/images/ui/icon-twitter-ec6e2f078db4b5090678d6a8f46dd549.png";